import type { FaireProductEntity } from "../../entity_types/product";

export const p_8kwzzxc9bw: FaireProductEntity = {
  token: "p_8kwzzxc9bw",
  type: "product",
  name: "Spa Bath Soak 2.5 oz - Eucalyptus Lavender",
  brandName: "Enfusia",
  imageUrl:
    "https://cdn.faire.com/fastly/14d3b5be6de6f691ff760d5a081f278b93f0f2be7d22273905d2911d49b82089.jpeg",
  priceDollars: 1.95,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/3bbdc3fc4d0d237ffd4bb9590390066d7f19ee7f52ea2a6ea4046c54e5d2addf.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
